import { Grid, GridColumn } from '@progress/kendo-react-grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { callApiWithAuthorization } from '../../../API/CallApi';
import Loader from '../../Shared/Loader/loader';
import useGetInvoices from './Hooks/useGetInvoices';
import { Menu, MenuItem } from '@progress/kendo-react-layout';

function InvoiceList({ organizationId, gridClassName = "w-50", subscriptionId, currentPriceId, onPayNowClick }) {

    const { invoices, loading, error } = useGetInvoices(organizationId, subscriptionId);

    if (loading) {
        return (
            <div className='w-50'>
                <Loader />
            </div>
        )
    }

    if (error) {
        return (
            <div className='w-50'>
                Something went wrong while getting your invoices.
                Please refresh and try again.
            </div>
        )
    }

    function showPayNowButtonForInvoice(invoice) {
        const invoiceCreatedAt = invoice.created * 1000;
        const today = new Date().getTime();
        return (
            invoice.status === "open" &&
            currentPriceId === invoice.lines.data[0].price.id &&
            today - invoiceCreatedAt < 95
        )
    }

    function handlePayNowClick(event, invoice) {
        onPayNowClick(event, invoice);
    }

    function getPayNowClassName(invoice) {
        switch (invoice.status) {
            case "paid":
                return " btn-success";
            case "uncollectible":
                return " btn-secondary";
            case "open":
                return " btn-danger";
            default:
                return " btn-primary";
        }
    }

    function getPayNowButtonText(invoice) {
        switch (invoice.status) {
            case "paid":
                return "Paid";
            case "uncollectible":
                return "Uncollectible";
            case "open":
                return "Open";
            default:
                return "Open";
        }
    }

    function getReceiptPdfUrl(invoice) {
        const charge = invoice.charge;
        if (charge && charge.receipt_url && charge.receipt_url !== "" && charge.receipt_url !== null) {
            const [url, queryParams] = charge.receipt_url.split("?");
            return url + "/pdf?" + queryParams;
        }
        return "";
    }

    return (
        <Grid
            className={gridClassName}
            data={invoices}>
            <GridColumn
                title='Amount'
                field='total'
                cell={props => (
                    <td>
                        ${ props.dataItem[props.field] / 100 }
                    </td>
                )} />
            <GridColumn
                title='Status'
                field='status'
                cell={props => (
                    <td>
                        <button className={"btn w-100" + getPayNowClassName(props.dataItem)}>
                            { getPayNowButtonText(props.dataItem) }
                        </button>
                    </td>
                )} />
            <GridColumn
                title='Due'
                field='period_end'
                width={150}
                cell={props => (
                    <td>
                        { moment(props.dataItem[props.field] * 1000).format("Do MMMM YYYY") }
                    </td>
                )} />
            <GridColumn
                cell={(props) => (
                    <td>
                        {
                            showPayNowButtonForInvoice(props.dataItem) &&
                            <button className='btn btn-primary' onClick={(event) => handlePayNowClick(event, props.dataItem)}>
                                Pay Now
                            </button>
                        }
                    </td>
                )} />
            <GridColumn
                cell={(props) => (
                    <td>
                        <Menu onSelect={(e) => e.item.data()} className="no-dropdown-in-menu">
							<MenuItem cssClass="btn btn-secondary px-1" icon="more-horizontal g-0 m-0 ps-2" data={() => { }}>
								<MenuItem
                                    text="Download Invoice"
                                    disabled={props.dataItem.invoice_pdf === "" || props.dataItem.invoice_pdf === null}
                                    url={props.dataItem.invoice_pdf}
                                />
								<MenuItem
                                    text="Download Receipt"
                                    disabled={getReceiptPdfUrl(props.dataItem) === ""}
                                    url={getReceiptPdfUrl(props.dataItem)}
                                />
							</MenuItem>
						</Menu>
                    </td>
                )} />
        </Grid>
    )
}

export default InvoiceList;